import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './CultureEvaluationsView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider, Button, Typography, Row } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableEvaluations from '../../../components/tableEvaluations/tableEvaluations';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import Search from '../../../components/search/search';
import { PlusOutlined } from '@ant-design/icons';
import FormEvaluation from '../../../components/formEvaluation/formEvaluation';
const { Paragraph, Title } = Typography;
const { Content } = Layout;

const CultureEvaluationsView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataEvaluations, setFilteredDataEvaluations] = useState([]);
    const [dataEvaluations, setDataEvaluations] = useState([]);
    const [orgId, setOrgId] = useState("");
    const [searchText, setSearchText] = useState("");

    const [openEvaluationForm, setOpenEvaluationForm] = useState(false);
    const [editEvaluation, setEditEvaluation] = useState(false);
    const [evaluationData, setEvaluationData] = useState(null);
    const [evlId, setEvlId] = useState(null);
    const [relEvlLatEagData, setRelEvlLatEagData] = useState([]);

    const [dataEvaluationAnswerGroups, setDataEvaluationAnswerGroups] = useState([]);
    const [dataCultureAttributes, setDataCultureAttributes] = useState([]);
    const [dataEmployees, setDataEmployees] = useState([]);

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getEvaluationAnswersGroups(current_org.org_id);
            getCultureAttributes(current_org.org_id);
            getEvaluations(current_org.org_id);
            getEmployees(current_org.org_id);
        }
    }, []);

    useEffect(() => {
        if (evaluationData && relEvlLatEagData) {
            setOpenEvaluationForm(true);
        }
    }, [evaluationData, relEvlLatEagData]);

    const getEvaluationAnswersGroups = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando escalas de respuesta...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/evaluation-answer-groups/get-evaluation-answer-groups-org/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataEvaluationAnswerGroups(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const getCultureAttributes = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando atributos culturales...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/culture-attributes/get-culture-attributes/${orgId}/`, headers)
            .then(function (response) {
                let data = response.data;
                // Aplicar deduplicación de atributos culturales
                data = deduplicateCultureAttributes(data);
                setDataCultureAttributes(data);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getEmployees = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/employees/get-employees-relationships/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataEmployees(data);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getEvaluations = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando evaluaciones de la organización...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/evaluations/get-evaluations/${orgId}/3/`, headers)
            .then(function (response) {
                let data = response.data;
                // Aplicar deduplicación de datos
                data = deduplicateEvaluations(data);
                setDataEvaluations(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataEvaluations(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const getEvaluationById = (evlId) => {
        setShowLoading(true);
        setLoadingText("Cargando evaluación...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/evaluations/get-evaluation-by-id/${evlId}/?include_relationships=false`, headers)
            .then(function (response) {
                const data = response.data;
                setEvaluationData(data);
                setRelEvlLatEagData(data.rel_question_answer_option || []);
                setEvlId(data.evl_id);
                setShowLoading(false);
                setEditEvaluation(true);
                // setOpenEvaluationForm(true);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de evaluaciones
    const saveEvaluation = () => {
        setShowLoading(true);
        setLoadingText("Agregando evaluación...")

        const data = {
            evl_org_id: orgId,
            evl_srv_id: 3,
            evl_title: evaluationData.evl_title,
            evl_welcome_message: evaluationData.evl_welcome_message,
            evl_main_welcome_text: evaluationData.evl_main_welcome_text,
            evl_introductory_text: evaluationData.evl_introductory_text,
            evl_question_display_mode: evaluationData.evl_question_display_mode,
            evl_questions_per_page: evaluationData.evl_questions_per_page,
            evl_start_date: evaluationData.evl_start_date,
            evl_finish_date: evaluationData.evl_finish_date,
            evl_email_message: evaluationData.evl_email_message,
            evl_email_responsible: evaluationData.evl_email_responsible,
            evl_email_responsible_job_title: evaluationData.evl_email_responsible_job_title,
            evl_email_responsible_email: evaluationData.evl_email_responsible_email,
            evl_final_message: evaluationData.evl_final_message,
            evl_min_red_light: evaluationData.evl_min_red_light,
            evl_max_red_light: evaluationData.evl_max_red_light,
            evl_min_yellow_light: evaluationData.evl_min_yellow_light,
            evl_max_yellow_light: evaluationData.evl_max_yellow_light,
            evl_min_green_light: evaluationData.evl_min_green_light,
            evl_max_green_light: evaluationData.evl_max_green_light,
            evl_min_blue_light: evaluationData.evl_min_blue_light,
            evl_max_blue_light: evaluationData.evl_max_blue_light,
            evl_indicators_porcentage: evaluationData.evl_indicators_porcentage,
            evl_competencies_porcentage: evaluationData.evl_competencies_porcentage,
            evl_comments_option: evaluationData.evl_comments_option,
            evl_answer_options: evaluationData.evl_answer_options,
            evl_questions: evaluationData.evl_questions,
            evl_rel_evl_cmp_eag: relEvlLatEagData,
          };

        if (evaluationData.evl_relationships_loaded !== false) {
            data.evl_relationships = evaluationData.evl_relationships;
        }


        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/evaluations/create-evaluation/`, data, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getEvaluations(orgId);
                setShowLoading(false);
                setOpenEvaluationForm(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para editar el nombre de un evaluaciones
    const updateEvaluation = () => {
        setShowLoading(true);
        setLoadingText("Editando evaluación...")

        const data = {
            evl_id: evaluationData.evl_id,
            evl_org_id: orgId,
            evl_srv_id: 3,
            evl_title: evaluationData.evl_title,
            evl_welcome_message: evaluationData.evl_welcome_message,
            evl_main_welcome_text: evaluationData.evl_main_welcome_text,
            evl_introductory_text: evaluationData.evl_introductory_text,
            evl_question_display_mode: evaluationData.evl_question_display_mode,
            evl_questions_per_page: evaluationData.evl_questions_per_page,
            evl_start_date: evaluationData.evl_start_date,
            evl_finish_date: evaluationData.evl_finish_date,
            evl_email_message: evaluationData.evl_email_message,
            evl_email_responsible: evaluationData.evl_email_responsible,
            evl_email_responsible_job_title: evaluationData.evl_email_responsible_job_title,
            evl_email_responsible_email: evaluationData.evl_email_responsible_email,
            evl_final_message: evaluationData.evl_final_message,
            evl_min_red_light: evaluationData.evl_min_red_light,
            evl_max_red_light: evaluationData.evl_max_red_light,
            evl_min_yellow_light: evaluationData.evl_min_yellow_light,
            evl_max_yellow_light: evaluationData.evl_max_yellow_light,
            evl_min_green_light: evaluationData.evl_min_green_light,
            evl_max_green_light: evaluationData.evl_max_green_light,
            evl_min_blue_light: evaluationData.evl_min_blue_light,
            evl_max_blue_light: evaluationData.evl_max_blue_light,
            evl_indicators_porcentage: evaluationData.evl_indicators_porcentage,
            evl_competencies_porcentage: evaluationData.evl_competencies_porcentage,
            evl_comments_option: evaluationData.evl_comments_option,
            evl_answer_options: evaluationData.evl_answer_options,
            evl_questions: evaluationData.evl_questions,
            evl_rel_evl_cmp_eag: relEvlLatEagData,
        };

        if (evaluationData.evl_relationships_loaded !== false) {
            data.evl_relationships = evaluationData.evl_relationships;
        }

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/evaluations/update-evaluation/${evlId}/`, data, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getEvaluations(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de evaluaciones
    const handleDeleteTable = (evl_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando evaluaciones...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/evaluations/delete-evaluation/${evl_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getEvaluations(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataEvaluations)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataEvaluations(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.evl_title.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataEvaluations(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    // Función para deduplicar atributos culturales por cat_id
    const deduplicateCultureAttributes = (data) => {
        const seen = new Set();
        return data.filter(item => {
            if (seen.has(item.cat_id)) {
                return false;
            }
            seen.add(item.cat_id);
            return true;
        });
    }

    // Función para deduplicar datos por evl_id
    const deduplicateEvaluations = (data) => {
        const seen = new Set();
        return data.filter(item => {
            if (seen.has(item.evl_id)) {
                return false;
            }
            seen.add(item.evl_id);
            return true;
        });
    }

    // Función para validar si una evaluación ya existe
    const validateUniqueEvaluation = (evaluationTitle, currentId = null) => {
        return dataEvaluations.some(item => 
            item.evl_title.toLowerCase().trim() === evaluationTitle.toLowerCase().trim() && 
            item.evl_id !== currentId
        );
    }

    const openForm = (edit, evlId) => {
        if (edit) {
            getEvaluationById(evlId);
        } else {
            setEditEvaluation(false);
            let objEvaluation = {
                evl_id: null,
                evl_title: "",
                evl_welcome_message: "",
                evl_main_welcome_text: "",
                evl_introductory_text: "",
                evl_question_display_mode: "grouped",
                evl_questions_per_page: 10,
                evl_start_date: "",
                evl_finish_date: "",
                evl_email_message: "",
                evl_email_responsible: "",
                evl_email_responsible_job_title: "",
                evl_email_responsible_email: "",
                evl_final_message: "",
                evl_min_red_light: 0,
                evl_max_red_light: "",
                evl_min_yellow_light: "",
                evl_max_yellow_light: "",
                evl_min_green_light: "",
                evl_max_green_light: "",
                evl_min_blue_light: "",
                evl_max_blue_light: 100,
                evl_indicators_porcentage: 0,
                evl_competencies_porcentage: 0,
                evl_comments_option: 0,
                evl_answer_options: [],
                evl_relationships: [],
                evl_questions: [],
            }
            setEvlId(null);
            setEvaluationData(objEvaluation);
            setRelEvlLatEagData([]);
            // setOpenEvaluationForm(true);
        }
    }

    const closeForm = () => {
        setOpenEvaluationForm(false);
        setEditEvaluation(false);
        setEvaluationData(null);
        setRelEvlLatEagData([]);
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            {
                !openEvaluationForm && <div className='layout-content'>
                    <Typography className='display-center-row display-center-column'>
                        <Title type='primary' level={3}>Gestión de evaluaciones de cultura</Title>
                    </Typography>
                    <Row justify="center">
                        <Button className='btn-add' type="primary" icon={<PlusOutlined />} onClick={() => openForm(false)}>
                            Agregar evaluación
                        </Button>
                    </Row>
                    <Divider/>
                    <Search onSearch={onSearch} />
                    <br></br>
                    <TableEvaluations data={filteredDataEvaluations} openForm={openForm} handleDelete={handleDeleteTable} />
                </div>
            }
            {
                openEvaluationForm && <div className='layout-content'>
                    <Typography className='display-center-row display-center-column'>
                        <Title type='primary' level={3}>{editEvaluation ? `Editar evaluación` : `Crear nueva evaluación` }</Title>
                    </Typography>
                    <FormEvaluation 
                        data={evaluationData} 
                        relEvlCmpEag={relEvlLatEagData}
                        setRelEvlCmpEag={setRelEvlLatEagData}
                        dataCompetencies={dataCultureAttributes} 
                        dataEvaluationAnswerGroups={dataEvaluationAnswerGroups}
                        dataEmployees={dataEmployees}
                        setData={setEvaluationData} 
                        onSave={editEvaluation ? updateEvaluation : saveEvaluation} 
                        onCancel={closeForm} 
                        showSwal={showSwal}
                        type={"culture"} 
                    />
                </div>
            }
            
        </Content>
    </div>
}

export default CultureEvaluationsView;